export const defaultPageSize = {
    width: 354,
    height: 498,
};

export function pageSizeFromMagazine(magazine) {
    return pageSizeFromPropertiesJSON(magazine?.properties);
}

export function pageSizeFromPropertiesJSON(json) {
    return pageSizeFromProperties(JSON.parse(json));
}

export function pageSizeFromProperties(properties) {
    return properties?.pageSize || defaultPageSize;
}

export const predefinedSizes = {
    "a5": {width: 14.8, height: 21.0, unit: "cm"},
    "a4": {width: 21.0, height: 29.7, unit: "cm"},
    "a3": {width: 29.7, height: 42.0, unit: "cm"},
    "letter": {width: 8.5, height: 11.0, unit: "in"},
    "tabloid": {width: 11.0, height: 17.0, unit: "in"},
    "post-card": {width: 4.0, height: 6.0, unit: "in"},
    "business-card": {width: 3.5, height: 2.0, unit: "in"},
    "presentation": {width: 1920.0, height: 1080.0, unit: "px"},
    "square": {width: 1080.0, height: 1080.0, unit: "px"},
    "story-reel": {width: 1080.0, height: 1920.0, unit: "px"},
};

export const sizeUnits = {
    mm: 3.77952755906,
    cm: 3.77952755906 * 10,
    in: 3.77952755906 * 10 * 2.54,
};

const LEGACY_DEFAULT_PAGE_SIZE = { width: 354, height: 498 };
const LEGACY_DEFAULT_PDF_SIZE_MM = { width: 350, height: 500 };

function isLegacyDefaultPageSize(pageSize) {
    return pageSize.width === LEGACY_DEFAULT_PAGE_SIZE.width
        && pageSize.height === LEGACY_DEFAULT_PAGE_SIZE.height;
}

export function toPdfPageSizeMm(pageSize) {
    if (isLegacyDefaultPageSize(pageSize)) {
        return { ...LEGACY_DEFAULT_PDF_SIZE_MM };
    }

    return {
        width: pageSize.width / sizeUnits.mm,
        height: pageSize.height / sizeUnits.mm,
    };
}

export function getPdfExportConfig(pageSize) {
    const pageSizeMm = toPdfPageSizeMm(pageSize);
    const exportWidthPx = pageSizeMm.width * sizeUnits.mm;
    const exportHeightPx = pageSizeMm.height * sizeUnits.mm;
    const scaleFactor = exportWidthPx / pageSize.width;

    return {
        pageSizeMm,
        exportWidthPx,
        exportHeightPx,
        scaleFactor,
    };
}


// WEBPACK FOOTER //
// ./src/utils/pageSize.js